import { breakpoints } from '@latitude/theme/breakpoints';
import { useSyncExternalStore } from 'react';

export type Layout = 'mobile' | 'tablet' | 'desktop';

export type Breakpoint = {
  layout: Layout;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

const pxToNumber = (value: string) => Number.parseInt(value, 10);

export const MOBILE_MEDIA_QUERY = `(max-width: ${pxToNumber(breakpoints.screens.sm) - 1}px)`;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${pxToNumber(breakpoints.screens.lg)}px)`;

const readLayout = (): Layout => {
  if (typeof window === 'undefined') {
    return 'desktop';
  }
  if (window.matchMedia(MOBILE_MEDIA_QUERY).matches) {
    return 'mobile';
  }
  return window.matchMedia(DESKTOP_MEDIA_QUERY).matches ? 'desktop' : 'tablet';
};

const subscribe = (onChange: () => void) => {
  const mobileQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
  const desktopQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
  mobileQuery.addEventListener('change', onChange);
  desktopQuery.addEventListener('change', onChange);

  return () => {
    mobileQuery.removeEventListener('change', onChange);
    desktopQuery.removeEventListener('change', onChange);
  };
};

const getServerSnapshot = (): Layout => 'desktop';

export const useBreakpoint = (): Breakpoint => {
  const layout = useSyncExternalStore(subscribe, readLayout, getServerSnapshot);

  return {
    layout,
    isMobile: layout === 'mobile',
    isTablet: layout === 'tablet',
    isDesktop: layout === 'desktop',
  };
};
